import styled from "styled-components";

export const HeaderActionsStyled = styled.div`
  .info-buttons {
    display: flex;
    justify-content: flex-end;
    align-items: center;
    gap: 8px;
    flex-shrink: 0;
  }

  .info-buttons .button-instance {
    width: 145px;
  }

  .est-status {
    display: flex;
    align-items: center;
    gap: 5px;
  }

  .action-btns {
    display: flex;
    align-items: center;
    gap: 8px;
    button {
      height: 36px;
    }
  }

  .menu-wrapper {
    cursor: pointer;
  }

  .select {
    p {
      font-size: 12px;
    }
  }
`;
